<template>
  <el-form-item
    :label="label"
    class="date"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="date"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: 'date'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: []
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (date) {
        this.$emit('change', date)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    var list = []

    var syoriFrom = 1
    var syoriTo = 31
    for (let i = syoriFrom; i <= syoriTo; i++) {
      list.push({ key: String(i), code_value: String(i) })
    }
    const date = list
    const dateSet = [...new Set(date.map((x) => x.code_value))]
    this.options = dateSet.map((x) => { return { value: x, label: x } })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.date {
  ::v-deep .el-form-item__content {
    width: 8em;
  }
}
</style>
